import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { ContractSettingsRepository } from '../application/ContractSettingsRepository'

/**
 * Seule la lecture se replie. Une écriture qui échoue doit échouer :
 * activer des paramètres en mémoire ferait croire à une configuration
 * enregistrée qui n'existe nulle part.
 */
export function createResilientContractSettingsRepository(
  primary: ContractSettingsRepository,
  fallback: ContractSettingsRepository,
): ContractSettingsRepository {
  return {
    async listSeasons() {
      try {
        return await primary.listSeasons()
      } catch (error) {
        reportUnexpectedError(error, {
          feature: 'contracts',
          operation: 'contract-settings-list',
          fallback: true,
        })
        const result = await fallback.listSeasons()
        return {
          ...result,
          meta: {
            ...result.meta,
            source: 'fixture-fallback',
            fallbackReason: 'CONTRACT_SETTINGS_REMOTE_UNAVAILABLE',
          },
        }
      }
    },
    async listClauseTemplates() {
      try {
        return await primary.listClauseTemplates()
      } catch (error) {
        // Une bibliothèque indisponible se lit vide, jamais approximée : un
        // gabarit inventé finirait recopié dans une saison neuve.
        reportUnexpectedError(error, {
          feature: 'contracts',
          operation: 'contract-clause-templates-list',
          fallback: true,
        })
        return await fallback.listClauseTemplates()
      }
    },
    upsertClauseTemplate(command) {
      return primary.upsertClauseTemplate(command)
    },
    reorderClauseTemplates(keys) {
      return primary.reorderClauseTemplates(keys)
    },
    createSeason(label) {
      return primary.createSeason(label)
    },
    duplicateSeason(command) {
      return primary.duplicateSeason(command)
    },
    activateSeason(seasonId) {
      return primary.activateSeason(seasonId)
    },
    activateVersion(command) {
      return primary.activateVersion(command)
    },
  }
}
